import Axios from "axios";
import { useEffect, useReducer } from "react";
import { dataFetchReducer } from "./utils/dataFetchReducer";
import { parseTournamentData } from "./parseTournamentData";
import { getConfiguration } from './utils/configuration';
import { systemCode, xs_languageCode } from '..';

export function useFetchTournamentData(data, tournament, aggregata, shouldExecute, reload, compattaParametriche) {
    const controller = new AbortController();
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });
    
    useEffect(() => {
        if (!shouldExecute) {
        	controller.abort();
            return;
        }
        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params, signal: controller.signal});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };

        const url = getConfiguration().api.getTorneoCentrale;
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
            sportId: tournament.sportRef,
            categoryId: tournament.categoryRef,
            tournamentId: tournament.id,
            idAggregata: aggregata
        }
        fetchData(url, params, function(response) {
            if (response == null || response === '') {
                dispatch({ type: 'FETCH_FAILURE' });
            }
            const tournamentData = parseTournamentData(data, response, tournament.uniqueId, aggregata, false, compattaParametriche);
            dispatch({ type: 'FETCH_SUCCESS', payload: tournamentData });
        });
        
        return () => {
        	controller.abort();
            didCancel = true;
        };
    }, [data, tournament, aggregata, shouldExecute, reload, compattaParametriche]);

    return [state, dispatch];
}